import React, { ReactNode, useEffect } from "react";
import styles from "./MainTemplate.module.css";
import clsx from "clsx";

interface MainTemplateProps {
  header?: ReactNode;
  body: ReactNode;
  footer?: ReactNode;
  hasOverlayFooter?: boolean;
  backgroundStyle?: React.CSSProperties;
  fullWidthHeader?: boolean;
  fullWidthHeaderIpad?: boolean;
}

const MainTemplate = ({
  header,
  body,
  footer,
  hasOverlayFooter = false,
  backgroundStyle,
  fullWidthHeader = false,
  fullWidthHeaderIpad = false,
}: MainTemplateProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className={clsx(hasOverlayFooter && styles["overlay-main-container"])}
      style={backgroundStyle}
    >
      <div className={clsx(hasOverlayFooter && styles["overlay-body"])}>
        {header && (
          <div
            className={clsx(
              !fullWidthHeader && styles["header"],
              fullWidthHeaderIpad && styles["header-ipad"]
            )}
          >
            {header}
          </div>
        )}
        {body}
      </div>
      <div className={clsx(hasOverlayFooter && styles["overlay-footer"])}>
        {footer}
      </div>
    </div>
  );
};

export default MainTemplate;
